module.exports = "<ng-template #prevention let-c=\"close\" let-d=\"dismiss\">\n\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/prevention-modal/prevention-modal.component.html
// module id = ./src/app/prevention-modal/prevention-modal.component.html
// module chunks = main